import { Box } from '@mui/material';

const DOT_SIZE = 5;
const DOT_GAP = 2;
const DOT_RADIUS = DOT_SIZE / 2;
const DOT_TILE = DOT_SIZE + DOT_GAP;

interface HiddenValueDotsProps {
  testId?: string;
}

const HiddenValueDots = ({ testId }: HiddenValueDotsProps) => (
  <Box
    test-id={testId}
    sx={{
      width: '100%',
      height: DOT_SIZE,
      backgroundImage: `radial-gradient(circle at 50% 50%, currentColor 0 ${DOT_RADIUS}px, transparent ${DOT_RADIUS}px)`,
      backgroundSize: `${DOT_TILE}px ${DOT_SIZE}px`,
      backgroundRepeat: 'space no-repeat',
      backgroundPosition: 'left center',
    }}
  />
);

export default HiddenValueDots;
